const FeatureFlags = {
  TEACHER_ASSIGNMENT_ASSIGN: 'release-teacher-assignment-assign',
  ALEF_ASSIGNMENT_ASSIGN: 'release-alef-assignment-assign',
  ENABLE_AZURE_FILE_STORAGE: 'enable-azure-file-storage',
};

export default FeatureFlags;
